// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3g_E9","colMaxWidth":"Table_colMaxWidth__tHSwE"};